import { render, staticRenderFns } from "./KTCForeverPlanCreate.vue?vue&type=template&id=123fe78a&"
import script from "./KTCForeverPlanCreate.vue?vue&type=script&lang=js&"
export * from "./KTCForeverPlanCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports